import { createContext, useContext } from 'react';

/**
 * Whether the list row around a control holds its list's one Tab stop.
 * Undefined outside such a list, where controls keep their own Tab order.
 */
export const RowTabStopContext = createContext<boolean | undefined>(undefined);

/**
 * The tabIndex for a row or a button inside it: -1 while another row of the
 * list holds the Tab stop, so Tab passes the whole list in one step.
 */
export const useRowTabIndex = () =>
    useContext(RowTabStopContext) === false ? -1 : undefined;
